import React from "react";
import { Link } from "react-router-dom";
import "./Landing_Page.css";

const features = [
  { icon: "fa-stethoscope", title: "Find Specialists", desc: "Search by specialty and book verified doctors in seconds.", hue: "purple" },
  { icon: "fa-bolt", title: "Instant Consultation", desc: "Connect with a doctor immediately when you need urgent advice.", hue: "cyan" },
  { icon: "fa-calendar-check-o", title: "Smart Scheduling", desc: "Pick date and time slots that fit your routine effortlessly.", hue: "coral" },
  { icon: "fa-shield", title: "Secure Records", desc: "Manage your profile and medical reports in one secure place.", hue: "mint" },
];

const steps = [
  { num: "01", title: "Sign up", text: "Create your free patient account in under a minute." },
  { num: "02", title: "Find a doctor", text: "Search by specialty and compare ratings." },
  { num: "03", title: "Book & consult", text: "Schedule or start an instant video consultation." },
];

const LandingPage = () => {
  return (
    <div className="landing">
      <div className="landing-mesh" />

      <section className="landing-hero">
        <div className="landing-hero__content">
          <span className="landing-badge">
            <i className="fa fa-heartbeat" /> Trusted healthcare platform
          </span>
          <h1>
            Your Health,
            <br />
            <span className="text-gradient">Our Priority</span>
          </h1>
          <p className="landing-hero__desc">
            Book doctors, get instant consultations, and manage your care — all in
            one beautiful, secure platform built for modern patients.
          </p>
          <div className="landing-hero__actions">
            <Link to="/home" className="btn-primary-solid">
              Get Started <i className="fa fa-arrow-right" />
            </Link>
            <Link to="/bookingconsultation" className="btn-outline">
              Book Appointment
            </Link>
          </div>
          <div className="landing-stats">
            <div className="landing-stat landing-stat--purple">
              <strong>50+</strong>
              <span>Specialties</span>
            </div>
            <div className="landing-stat landing-stat--cyan">
              <strong>24/7</strong>
              <span>Live Access</span>
            </div>
            <div className="landing-stat landing-stat--coral">
              <strong>4.9★</strong>
              <span>Patient Rating</span>
            </div>
          </div>
        </div>

        <div className="landing-hero__visual">
          <div className="landing-hero__card landing-float">
            <div className="landing-hero__card-glow" />
            <div className="landing-hero__avatar">
              <i className="fa fa-user-md" />
            </div>
            <h3>Dr. Sarah Ahmed</h3>
            <p className="landing-hero__specialty">General Physician</p>
            <div className="landing-hero__tags">
              <span><i className="fa fa-star" /> 4.9</span>
              <span><i className="fa fa-clock-o" /> Available now</span>
            </div>
            <button type="button" className="landing-hero__book">Book Now</button>
          </div>
          <div className="landing-orb landing-orb--1" />
          <div className="landing-orb landing-orb--2" />
          <div className="landing-orb landing-orb--3" />
        </div>
      </section>

      <section className="landing-features">
        <div className="page-header">
          <span className="section-tag">Features</span>
          <h1>Everything you need to stay healthy</h1>
          <p>One vibrant platform for booking, consulting, and managing your health journey.</p>
        </div>
        <div className="landing-features__grid">
          {features.map((f) => (
            <article key={f.title} className={`landing-feature-card landing-feature-card--${f.hue}`}>
              <div className="landing-feature-card__icon">
                <i className={`fa ${f.icon}`} />
              </div>
              <h3>{f.title}</h3>
              <p>{f.desc}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="landing-steps">
        <div className="page-header">
          <span className="section-tag section-tag--light">How it works</span>
          <h1>Three simple steps</h1>
        </div>
        <div className="landing-steps__grid">
          {steps.map((s) => (
            <div key={s.num} className="landing-step">
              <span className="landing-step__num">{s.num}</span>
              <h3>{s.title}</h3>
              <p>{s.text}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="landing-cta">
        <h2>Ready to take control of your health?</h2>
        <p>Join thousands of patients already using StayHealthy.</p>
        <Link to="/signup" className="btn-primary-solid">
          Create Free Account
        </Link>
      </section>
    </div>
  );
};

export default LandingPage;
